import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { money, fmtDate } from "@/lib/constants";
import { useLang } from "@/i18n";

// "Nog openstaand" per gast: onbetaalde facturen, verkopen op rekening en waarborgen.
export default function OutstandingCard({ guestId }) {
  const { t } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!guestId) { setData(null); return; }
    api.get(`/guests/${guestId}/outstanding`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [guestId]);

  if (!data) return null;
  const empty = !data.invoices.length && !data.sales.length && !data.deposits.length;
  if (empty) {
    return (
      <p className="text-xs text-emerald-700" data-testid="outstanding-none">{t("outstanding_none")}</p>
    );
  }

  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 space-y-2 text-xs text-amber-900" data-testid="outstanding-card">
      <p className="flex items-center gap-1.5 font-semibold">
        <AlertTriangle className="h-4 w-4" />{t("outstanding_title")}
      </p>
      {data.invoices.length > 0 && (
        <div data-testid="outstanding-invoices">
          <p className="font-semibold">{t("settle_open_invoices")}</p>
          {data.invoices.map((i) => <p key={i.id}>{i.number} · {fmtDate(i.date)} · {money(i.total)}</p>)}
        </div>
      )}
      {data.sales.length > 0 && (
        <div data-testid="outstanding-sales">
          <p className="font-semibold">{t("outstanding_sales")}</p>
          {data.sales.map((s) => <p key={s.id}>{s.number} · {fmtDate(s.date)} · {money(s.total)}</p>)}
        </div>
      )}
      {data.deposits.length > 0 && (
        <div data-testid="outstanding-deposits">
          <p className="font-semibold">{t("outstanding_deposits")}</p>
          {data.deposits.map((d) => <p key={d.id}>{d.item} · {money(d.total)}</p>)}
        </div>
      )}
      <p className="border-t border-amber-300 pt-1.5 font-bold" data-testid="outstanding-total">
        {t("settle_total_open")}: {money(data.total)}
      </p>
    </div>
  );
}
